import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'ui-popup-layout',
  templateUrl: './popup-layout.component.html',
  styleUrls: ['./popup-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopupLayoutComponent {
  @Input() injected = false;
  @Input() widthAuto = false;
}
